import { Box, Checkbox, Chip, FormControlLabel, Grid, Tooltip} from "@mui/material";

import React, { ChangeEvent, FC} from "react";

import { AgencyCode } from "../../../reducers/states/agency";

import MobilityStrategyAgencyFilter from "./mobility-strategey-filter";



interface MobilityStrategyAgencyFiltersProps {
  props: {
    agencyFilters: string[];
    handleSwitchChange: (event: ChangeEvent<HTMLInputElement>) => void;
    handleStatusSwitchChange: (event: ChangeEvent<HTMLInputElement>) => void;
  };
}

const MobilityStrategyAgencyFilters: FC<MobilityStrategyAgencyFiltersProps> = ({ props }) => {

  return (
    <>
      <Grid container alignItems="center">
        <Grid item>
          <MobilityStrategyAgencyFilter
            props={{
              agency: AgencyCode.KCM,
              agencyFilters: props.agencyFilters,
              handleSwitchChange: props.handleSwitchChange,
            }}
          />
        </Grid>
        <Grid item>
          <MobilityStrategyAgencyFilter
            props={{
              agency: AgencyCode.SFD,
              agencyFilters: props.agencyFilters,
              handleSwitchChange: props.handleSwitchChange,
            }}
          />
        </Grid>
        <Grid item>
          <MobilityStrategyAgencyFilter
            props={{
              agency: AgencyCode.SPD,
              agencyFilters: props.agencyFilters,
              handleSwitchChange: props.handleSwitchChange,
            }}
          />
        </Grid>
        <Grid item>
          <MobilityStrategyAgencyFilter
            props={{
              agency: AgencyCode.WSP,
              agencyFilters: props.agencyFilters,
              handleSwitchChange: props.handleSwitchChange,
            }}
          />
        </Grid>
        <Grid item>
          <MobilityStrategyAgencyFilter
            props={{
              agency: AgencyCode.WSDOT,
              agencyFilters: props.agencyFilters,
              handleSwitchChange: props.handleSwitchChange,
            }}
          />
        </Grid>
        <Grid item>
          <MobilityStrategyAgencyFilter
            props={{
              agency: AgencyCode.SDOT,
              agencyFilters: props.agencyFilters,
              handleSwitchChange: props.handleSwitchChange,
            }}
          />
        </Grid>
        <Grid item>
          <MobilityStrategyAgencyFilter
            props={{
              agency: AgencyCode.ST,
              agencyFilters: props.agencyFilters,
              handleSwitchChange: props.handleSwitchChange,
            }}
          />
        </Grid>
        <Grid item>
          <MobilityStrategyAgencyFilter
            props={{
              agency: AgencyCode.Port,
              agencyFilters: props.agencyFilters,
              handleSwitchChange: props.handleSwitchChange,
            }}
          />
        </Grid>
        <Grid item>
          <MobilityStrategyAgencyFilter
            props={{
              agency: AgencyCode.NWSA,
              agencyFilters: props.agencyFilters,
              handleSwitchChange: props.handleSwitchChange,
            }}
          />
        </Grid>
        <Grid item>
          <MobilityStrategyAgencyFilter
            props={{
              agency: AgencyCode.OTHER,
              agencyFilters: props.agencyFilters,
              handleSwitchChange: props.handleSwitchChange,
            }}
          />
        </Grid>
        <Grid item>
          <Tooltip title="Displays only active mobility strategies when toggled on">
              <Box ml={1}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="Open Only"
                      
                      onChange={props.handleStatusSwitchChange}
                      checkedIcon={<Chip color={"primary"} variant="filled" label="Open Only"/>} 
                      icon={
                        <Chip
                          variant="outlined"
                          label="Open Only"
                        />
                      }
                    />
                  }
                  label=""
                />
              </Box>
              </Tooltip>
            </Grid>
      </Grid>
    </>
  );
};

export default MobilityStrategyAgencyFilters;